import React, { useState, useEffect, useContext, useRef } from "react";
import Grid from "@mui/material/Grid";
import DialogTitle from "@mui/material/DialogTitle";

import OutlinedInput from "@mui/material/OutlinedInput";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import Autocomplete from "@mui/material/Autocomplete";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import "./recruiterPrivateSkillAccess.css";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { NotificationManager } from "react-notifications";
import CircularProgress from "@mui/material/CircularProgress";
import getRecruiterPrivateTestAccessResponse from "../../apis/recruiterPrivateTestAccess/recruiterPrivateTestAccess";
import addRecruiterPrivateTestAccessResponse from "../../apis/recruiterPrivateTestAccess/addRecruiterPrivateTestAccess";
import updateRecruiterPrivateTestAccessResponse from "../../apis/recruiterPrivateTestAccess/updateRecruiterPrivateTestAccess";
import GetTestByRecruitmentPartner from "../../apis/recruiterPrivateSkillAccess/getTestByRecruitmentPartner";
import Checkbox from '@mui/material/Checkbox';
import Popper from '@mui/material/Popper';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { UserTypeContext } from "../../AppRoute";
import DataTable from "../../components/DataTable/DataTable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
import getallactivetests from "../../apis/Tests/getallactivetests";
import getallactiverecruiter from "../../apis/recruiters/getallactiverecruiter";

const RecruiterPrivateSkillAccess = ({ idContextTest }) => {
  const { userType, userIdType } = useContext(UserTypeContext);
  const history = useNavigate();
  const [modalIsEditOpen, setmodalIsEditOpen] = useState(false);
  const [privateTestId, setPrivateTestId] = useState([]);
  const [testList, setTestList] = useState([]);
  const [allrecruiters, setAllrecruiters] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [recruiterId, setRecruiterId] = useState("");
  const [recruiterName, setRecruiterName] = useState("");
  const [addModel, setAddModel] = useState(false);
  const [allActiveTest, setAllActiveTest] = useState([]);
  const [recruitmentOrg, setRecruitmentOrg] = useState([]);
  const [recruiterData, setRecruiterData] = useState([]);
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;
  const [selectRecruiterEmail, setSelectedRecruiterEmail] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTestId, setSelectedTestId] = useState("");
  const [selectedEmailId, setSelectedEmailId] = useState([]);
  const timer = useRef(-1);
  const [atvBtn, setAtvBtn] = useState(false);
  const hasLoadedOnce = useRef(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filters, setFilters] = useState([]);
  const [isdataloading, setisdataloading] = useState(false);
  const [testdataloading, settestdataLoading] = useState(false);
  const [recruiterdataLoading, setRecruiterDataLoading] = useState(false);

  const setOpenByTimer = (isOpen) => {
    clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      setOpen(isOpen);
    }, 200);
  };


  const getUserNameAndSkill = (allrecruiters) => {

    if (!Array.isArray(allrecruiters) || allrecruiters.length === 0) {
      setAllrecruiters([]);
      return;
    }

    let arr = [];

    for (let index = 0; index < allrecruiters.length; index++) {

      const item = allrecruiters[index];


      const testsArray = item?.Test
        ? item.Test
        : item?.test
          ? [item.test]
          : [];

      const a = testsArray
        .map((i) => i?.testName)
        .filter(Boolean)
        .join();

      const name =
        (item?.user?.firstName || "") +
        " " +
        (item?.user?.lastName || "");

      let recruitmentPartner = testsArray
        .map((item) => item?.recruitmentpartner?.name);

      recruitmentPartner = recruitmentPartner.filter(
        (item, index) => recruitmentPartner.indexOf(item) === index
      );

      recruitmentPartner = recruitmentPartner.filter(Boolean).join(", ");

      let customers = testsArray
        .map((item) => item?.customer?.name);

      customers = customers.filter(
        (item, index) => customers.indexOf(item) === index
      );

      customers = customers.filter(Boolean).join(", ");

      arr.push(
        Object.assign(
          item,
          { Test: testsArray },
          { allTests: a },
          { alluser: name.trim() },
          { recruitmentAndPartner: recruitmentPartner },
          { customer: customers }
        )
      );
    }

    setAllrecruiters(arr);
  };

  const getAllActiveTest = async () => {
    try {
      settestdataLoading(true);
      let result = await getallactivetests({ isClientSpecific: true });
      result = result.data.data;
      result = result.filter((item) => item.isActive === true && item.testtype.code === "Client-Specific");
      setAllActiveTest(result);
    } catch (error) {
      console.error(error);
      NotificationManager.error(
        "Failed to fetch tests",
        "Error",
        10000
      );
    }
    finally {
      settestdataLoading(false);
    }
  }

  const getTestsData = async (recruiterPartnerId) => {
    try {
      let res = await GetTestByRecruitmentPartner(recruiterPartnerId);
      setTestList(
        res.data.data
          ? res.data.data.filter(
            (item) =>
              item.isActive === true && (item.customer === null || item.customer.isActive === true)
          )
          : []
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllrecruiterPrivateSkillAccess = async (
    currentPage,
    pageSize,
    filters,
  ) => {
    try {
      if (isdataloading) return

      setisdataloading(true)

      let payload = {
        isSearching: true,
        page: currentPage,
        pageSize: pageSize,
        filters: filters,
      }

      const response = await getRecruiterPrivateTestAccessResponse(payload);

      const apiData = response?.data?.data || [];

      setTotalRecords(response?.data?.totalRecords || 0);

      getUserNameAndSkill(apiData);
      if (!hasLoadedOnce.current) {
        hasLoadedOnce.current = true;
      }

    } catch (error) {
      NotificationManager.error(
        "Failed to fetch data",
        "Error",
        10000
      );
    } finally {
      setisdataloading(false)
    }
  };




  const closeAddModel = () => {
    setAddModel(false);
    setRecruitmentOrg([]);
    setSelectedTestId("");
    setSelectedEmailId([]);
    setSelectedRecruiterEmail([]);
    setRecruiterData([]);
  }

  const openAddModel = () => {
    setAddModel(true);
  }

  const testChangeHandler = (e, value) => {
    if (value) {
      clearClick();
      setRecruiterData([]);
      setRecruitmentOrg(value.recruitmentpartner);
      setSelectedTestId(value.id);
    } else {
      setRecruitmentOrg([]);
      setSelectedTestId("");
      setRecruiterData([]);
    }
  }

  const recruiterChangeHandler = (e, value) => {
    let emailIds = value.map((item) => item.email)
    setSelectedEmailId(emailIds);
    setSelectedRecruiterEmail(value);
  }


  const addAllClick = () => {
    setOpenByTimer(false);
    let emailIds = recruiterData.map((item) => item.email)
    setSelectedEmailId(emailIds);
    setSelectedRecruiterEmail(recruiterData);
  }
  const clearClick = () => {
    clearTimeout(timer.current);
    setOpenByTimer(false);
    setSelectedRecruiterEmail([]);
    setSelectedEmailId([]);
  }
  const recruiterEmailDatas = function (props) {
    return (
      <>
        <Popper {...props}>
          <div className="poppercolor">
            <Button color="primary" variant="contained" onClick={addAllClick} className="popperbutton">
              Select All
            </Button>
            <Button color="primary" variant="contained" onClick={clearClick} className="popperbutton">
              Clear All
            </Button>
          </div>
          {props.children}
        </Popper>
      </>
    );
  };



  const privateSkillChangeHandler = async (e, value) => {
    if (value) {
      setPrivateTestId([]);
      var arr = [];
      for (var i = 0; i < value.length; i++) {
        arr.push(value[i].id);
      }
      setPrivateTestId(arr);
    } else {
      setPrivateTestId([]);
    }
  };


  const addRecruiterPrivateTest = async () => {
    setAtvBtn(true);

    if (selectedTestId !== "" && selectedEmailId.length > 0) {
      try {
        let payload = {
          recruiterEmailIds: selectedEmailId,
          testId: selectedTestId,
          createdBy: userIdType,
          updatedBy: userIdType,
        };
        await addRecruiterPrivateTestAccessResponse(payload);
        getAllrecruiterPrivateSkillAccess();
        NotificationManager.success(
          "Client-Specific skill added",
          "Success",
          10000
        );
        setAtvBtn(false);
        closeAddModel();
      } catch (error) {
        console.log("error", error);
      }
    } else {
      setAtvBtn(false);
      NotificationManager.error(
        "Please fill all the  mandatory fields",
        "Error",
        10000
      );
    }
  };

  const openEditModal = (recruiterId, event) => {
    let EditData = event;
    let userName = EditData.user.firstName + " " + EditData.user.lastName;
    setRecruiterName(userName);
    setRecruiterId(EditData.recruiterId);
    setSelectedTests(event.Test);
    getTestsData(event.Test[0].recruitmentpartner.id);
    setmodalIsEditOpen(true);
  };
  const closeEditModal = () => {
    setPrivateTestId([]);
    setRecruiterId("");
    setSelectedTests([]);
    setTestList([]);
    setmodalIsEditOpen(false);
  };
  const updateRecruiterPrivateSkill = async () => {
    setAtvBtn(true);
    let payload = {
      recruiterId: recruiterId,
      testId: privateTestId[0]?.id
        ? privateTestId.map((e) => e?.id)
        : privateTestId,
      createdBy: userIdType,
      updatedBy: userIdType,
    };
    try {
      await updateRecruiterPrivateTestAccessResponse(
        recruiterId,
        payload
      );
      getAllrecruiterPrivateSkillAccess();
      setAtvBtn(false);
      NotificationManager.success(
        "Client-Specific skill updated",
        "Success",
        10000
      );
    } catch (error) {
      setAtvBtn(false);
      NotificationManager.error(
        "Client-Specific skill update failed",
        "Error",
        10000
      );
    }
    setPrivateTestId([]);
    setRecruiterId("");
    setSelectedTests([]);
    setTestList([]);
    setmodalIsEditOpen(false);
  };


  const closeButton = {
    position: "absolute",
    right: "7px",
    top: "12px",
    color: "grey",
  };

  const btnGreen = {
    color: "#fff",
    backgroundColor: "#1885e6",
    border: "none",
    padding: "7px 23px 7px 23px",
    float: "right",
    marginTop: "20px",
  };
  const btnSavegreen = {
    width: "115px"
  };


  const getValuesEdit = () => {
    let arr = [];
    for (let i = 0; i < selectedTests.length; i++) {
      for (let j = 0; j < testList.length; j++) {
        if (selectedTests[i].id === testList[j].id) {
          arr.push(testList[j]);
        }
      }
    }
    return arr;
  };

  const getActiveRecruiters = async () => {

    try {
      setRecruiterDataLoading(true);

      let payload = {
        recruitmentpartnerId: recruitmentOrg.id,
        testId: selectedTestId
      }

      let result = await getallactiverecruiter(payload)

      result = result.data.data;
      setRecruiterData(result);
    } catch (error) {
      NotificationManager.error(
        "Failed to fetch recruiters",
        "Error",
        10000
      );
    }
    finally {
      setRecruiterDataLoading(false);
    }

    
  }



  const columns = [
    {
      id: "edit",
      header: "Action",
      cell: ({ row }) => (
        <Button
          variant="contained"
          color="primary"
          onClick={() => openEditModal(row.original.recruiterid, row.original)}
          className="editBtn_recruiterPrivateSkillAccess"
        >
          Edit
        </Button>
      ),
      size: 180,
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      id: "alluser",
      accessorKey: "alluser",
      header: "Recruiter Name",
      size: 400,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "user.email",
      accessorKey: "user.email",
      header: "Email",
      size: 400,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "testName",
      accessorKey: "allTests",
      header: "Test Name",
      size: 400,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "recruitmentOrg",
      accessorKey: "recruitmentAndPartner",
      header: "Recruitment Organization",
      size: 400,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "customer",
      accessorKey: "customer",
      header: "Customer",
      size: 400,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: 'includesString',
    }
  ]

  const goToDashboard = () => {
    history("/admin-home");
  };


  useEffect(() => {

    let timervalue = filters.length > 0 ? 500 : 0

    if (!userType) return;
    const timeoutId = setTimeout(() => {
      getAllrecruiterPrivateSkillAccess(currentPage, pageSize, filters);
    }, timervalue);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [currentPage, pageSize, filters, userType]);



  return (
    <>
      <div className="main_container_recruiterPrivateSkillAccess">
        {userType === "Admin" ? (
          <Grid container spacing={3} className="main_gridContainer_privateskillaccess">
            <div className="container_privateskillaccess">
              <div className="communityHeader_manageUser ">
                <div className="goBackButton" onClick={(e) => goToDashboard(e)}>
                  <Tooltip title="Go Back to Dashboard" placement="bottom">
                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                  </Tooltip>
                </div>
                <div className="communityTitle">Client-Specific Test Access</div>
              </div>
              <Grid item xs>
                <Button
                  variant="outlined"
                  style={btnGreen}
                  color="primary"
                  onClick={openAddModel}
                >
                  Add Test Access
                </Button>
              </Grid>
            </div>
            <Grid item xs={12} md={12}>
              <DataTable
                data={allrecruiters}
                columns={columns}
                isLoading={isdataloading}
                isServerSide={true}
                totalRecords={totalRecords}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={(page, size) => {
                  setCurrentPage(page);
                  setPageSize(size);
                }}
                onPageSizeChange={(size) => {
                  setPageSize(size);
                  setCurrentPage(1);
                }}
                onFilterChange={(newFilters) => {
                  setFilters(newFilters);
                  setCurrentPage(1);
                }}
              />

            </Grid>
          </Grid>
        ) : userType === "" ? (
          <div className="row padding_80 text-center">
            <p className="fs-semi-bold fs-40 f-color">
              Loading...
            </p>
          </div>) : (
          <UnauthorizedAccess />
        )}
      </div>

      {/*  Add Client-Specific Modal  */}

      <Dialog
        onClose={closeAddModel}
        aria-labelledby="customized-dialog-title"
        open={addModel}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_privateskillaccess"
          >
            Add Client-Specific Test Access
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={closeAddModel}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Test Name*</Typography>
          <FormControl fullWidth variant="outlined">
            <Autocomplete
              id="combo-box-demo"
              filterSelectedOptions
              loading={testdataloading}
              onFocus={allActiveTest.length === 0 ? getAllActiveTest : null}
              options={allActiveTest}
              getOptionLabel={(option) => option.testName || []}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select Test"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {testdataloading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
              onChange={testChangeHandler}
            />
          </FormControl>
          &nbsp;
          {recruitmentOrg.name ?
            <>
              <Typography gutterBottom>Recruitment Organization*</Typography>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  id="combo-box-demo"
                  filterSelectedOptions
                  options={recruitmentOrg}
                  value={recruitmentOrg}
                  disabled
                  getOptionLabel={(option) => option.name || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Recruitment Organization"
                    />
                  )}
                />
              </FormControl>
              &nbsp;
              <Typography gutterBottom>Recruiter Email*</Typography>
              <FormControl fullWidth variant="outlined">
                <Autocomplete
                  id="combo-box-demo"
                  multiple
                  options={recruiterData || []}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.email}
                  value={selectRecruiterEmail}
                  onOpen={() => setOpenByTimer(true)}
                  onClose={() => setOpenByTimer(false)}
                  open={open}
                  loading={recruiterdataLoading}
                  onFocus={recruiterData.length === 0 ? getActiveRecruiters : null }
                  slots={{
                    popper: recruiterEmailDatas, // replaces PopperComponent
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.email}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Recruiter Email"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {recruiterdataLoading ? <CircularProgress color="inherit" size={20} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  onChange={recruiterChangeHandler}
                />
              </FormControl>

            </>
            : ''}
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" className="btn3" color="primary" onClick={closeAddModel}>
              Cancel
            </Button>

            <button variant="outlined" className="btn3 btn_primary cp" disabled={atvBtn} onClick={addRecruiterPrivateTest}>
              <div className="btn_loader">
                Save
                &nbsp;
                {atvBtn &&
                  <div>
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Dialog>
      {/*  Edit Client-Specific Modal  */}
      <Dialog
        onClose={closeEditModal}
        aria-labelledby="customized-dialog-title"
        open={modalIsEditOpen}
        PaperProps={{
          style: {
            width: "600px",
          },
        }}
      >
        <div className="Recruiter_Private_Skill_Modal">
          <DialogTitle
            id="customized-dialog-title"
            className="admindailog_title_modal_privateskillaccess"
            onClose={closeEditModal}
          >
            Edit Client-Specific Test Access
            <IconButton
              aria-label="close"
              style={closeButton}
              onClick={closeEditModal}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
        </div>
        <DialogContent>
          <Typography gutterBottom>Recruiter*</Typography>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              className="admin_textbox"
              defaultValue={recruiterName}
              disabled={true}
            />
          </FormControl>
          &nbsp;
          <Typography gutterBottom>Test*</Typography>
          {testList.length > 0 ? (
            <FormControl fullWidth variant="outlined">
              <Autocomplete
                multiple
                id="combo-box-demo"
                options={testList}
                getOptionLabel={(option) => option.testName}
                defaultValue={getValuesEdit()}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Client-Specific Test"
                  />
                )}
                onChange={privateSkillChangeHandler}
              />
            </FormControl>
          ) : (
            ""
          )}
        </DialogContent>
        <Grid size={{ xs: 12, md: 12 }} className="user_pop_button">
          <DialogActions>
            <Button variant="outlined" color="primary" onClick={closeEditModal} style={btnSavegreen}>
              Cancel
            </Button>
            <button
              variant="outlined"
              style={btnSavegreen}
              className="btn3 btn_primary cp"
              color="primary"
              onClick={updateRecruiterPrivateSkill}
              disabled={atvBtn}
            >
              <div className="btn_loader">
                Update
                &nbsp;
                {atvBtn &&
                  <div>
                    <CircularProgress size={13} />
                  </div>
                }
              </div>
            </button>
          </DialogActions>
        </Grid>
      </Dialog>
    </>
  );
};

export default RecruiterPrivateSkillAccess;

